import { render, staticRenderFns } from "./RoyaltiesCompute.vue?vue&type=template&id=785cc9c1&scoped=true"
import script from "./RoyaltiesCompute.vue?vue&type=script&lang=js"
export * from "./RoyaltiesCompute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785cc9c1",
  null
  
)

export default component.exports